// src/utils/widgetDataUpdater.ts

import { isPopularItemsWidget } from "./widgetPatterns";
import type { MenuItem } from "../redux/slices/menuItemsSlice";
import type { Widget } from "./widgetUtils";

export function updateWidgetsWithMenuData(
  widgets: Widget[],
  menuData: MenuItem[],
): Widget[] {
  return widgets.map((widget) => {
    if (!isPopularItemsWidget(widget.type || "")) {
      return widget;
    }

    const selectedItemIds = widget.data?.selectedItemIds ?? [];

    const updatedWidget: Widget = {
      ...widget,

      data: {
        ...(widget.data || {}),

        menuData: structuredClone(menuData),

        selectedItemIds,
      },
    };

    return updatedWidget;
  });
}
